"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var template = require('../panelHeader.jsx');

var displayNames = require('../../controls/displayNames');

var THEMES = ['standard', 'destructive', 'premium'];

var PanelHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelHeader, _React$Component);

  var _super = _createSuper(PanelHeader);

  function PanelHeader() {
    _classCallCheck(this, PanelHeader);

    return _super.apply(this, arguments);
  }

  _createClass(PanelHeader, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props = this.props,
          className = _this$props.className,
          onBack = _this$props.onBack,
          theme = _this$props.theme,
          removeStripe = _this$props.removeStripe,
          removeDivider = _this$props.removeDivider;
      var themeClassName = "theme-".concat(theme);
      return classNames(className, 'panel-header', 'panel-header-flex', themeClassName, {
        'has-back': onBack,
        'without-stripe': removeStripe,
        'without-divider': removeDivider
      });
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return PanelHeader;
}(React.Component);

PanelHeader.displayName = displayNames.PANEL_HEADER;
PanelHeader.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** Callback function, triggered when clicking on the header */
  onMouseDown: PropTypes.func,

  /** Callback function. When passed display a back button icon. Triggered when clicking on the back button. */
  onBack: PropTypes.func,

  /** Callback function. Triggered when clicking on the help icon button */
  onHelp: PropTypes.func,

  /** Callback function. Triggered when clicking on the close icon button */
  onClose: PropTypes.func,

  /** When set to true removes the close icon button */
  noCloseBtn: PropTypes.bool,

  /** When set to true removes the help icon button */
  noHelpBtn: PropTypes.bool,
  style: PropTypes.object,

  /** When passed, overrides the default close icon */
  closeSymbol: PropTypes.element,

  /** When passed, overrides the default help icon */
  helpSymbol: PropTypes.element,

  /** Set the color of the strip - work only for Classic Facelift skin */
  theme: PropTypes.oneOf(THEMES),

  /** Tooltip to display when hovering over the back icon button */
  backTooltipContent: PropTypes.string,

  /** Hook for old strategy testing for the back button icon */
  backAutomationId: PropTypes.string,

  /** A placeholder for a component that can contain buttons / anything else */
  actionsBar: PropTypes.node,

  /** Remove the color stripe on the top of the Panel Header. Classic Facelift Skin only */
  removeStripe: PropTypes.bool,

  /** Remove the divider on the bottom of the Panel Header. Classic Facelift Skin only */
  removeDivider: PropTypes.bool
};
PanelHeader.defaultProps = {
  dataHook: 'panel-header',
  theme: 'standard',
  removeStripe: false,
  removeDivider: false
};
module.exports = compose(PanelHeader);